<template>
  <div>
    <div class="offtaker__body">
      <div class="slider">
        <div class="row">
          <div class="col-6 col-lg-3"
               v-for="(crop, i) in crops"
               :key="i">

            <div class="slider__container box_curved_small">
              <div class="slider__container__img">
                <img :src="`${$baseImageUrl}/banners/auth_bg.jpg`" />
              </div>
              <div class="slider__container__content color__white">
                <h4 class="font-bold">{{crop.name}}</h4>
                <div class="listmeta color__white">
                  <span class="listMetaItem">{{crop.sellers_count}}
                    Sellers</span>
                  <span class="listMetaseperator">•</span>
                  <span class="listMetaItem">{{crop.total_yield | formatNumber}}
                    tons</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      crops: []
    };
  },
  methods: {
    getCrops() {
      this.$http
        .get("off_takers/crops")
        .then(({ data }) => {
          this.crops = [...data.items];
        })
        .catch(err => {
          this.$toastr.error(err);
        });
    }
  },
  created() {
    this.getCrops();
  }
};
</script>

<style>
</style>
